import { AuthStatus } from '@/core/store/auth.store';
import { TABS_PREFIX } from '@/core/router/app-paths';

const AUTH_RETURN_URL_KEY = 'authReturnUrl';

/** In-shell routes that logged-out visitors may still open (shared profile links). */
export function isPublicShellPath(pathname: string): boolean {
  return pathname.startsWith(`${TABS_PREFIX}/leads/public/`);
}

/** True while persisted tokens exist but `/auth/me` has not resolved yet. */
export function isAuthRoutePending(
  hydrated: boolean,
  authStatus: AuthStatus,
  accessToken: string | undefined,
): boolean {
  if (!hydrated) return true;
  return authStatus === AuthStatus.UNKNOWN && Boolean(accessToken);
}

export function isAppSessionActive(authStatus: AuthStatus): boolean {
  return (
    authStatus === AuthStatus.AUTHENTICATED || authStatus === AuthStatus.OFFLINE
  );
}

/** Remember a deep link so login can return here. Auth stack paths are skipped. */
export function persistAuthReturnUrl(pathWithSearch: string): void {
  if (pathWithSearch.startsWith('/auth')) return;
  sessionStorage.setItem(AUTH_RETURN_URL_KEY, pathWithSearch);
}

export function shouldMountAppShell(
  authStatus: AuthStatus,
  pathname: string,
): boolean {
  return isAppSessionActive(authStatus) || isPublicShellPath(pathname);
}

/** Paths owned by `IonTabs` / `#main-tabs` (not the root auth outlet). */
export function isShellTreePath(pathname: string): boolean {
  return pathname.startsWith(TABS_PREFIX);
}

/**
 * Mount the authenticated shell as a sibling of the root `IonRouterOutlet`,
 * never as a PageManager child of it. Ionic stacks then live only under
 * `#main-tabs` — auth→shell is a hard tree swap, not a root-outlet enter.
 */
export function shouldRenderAppShellTree(
  authStatus: AuthStatus,
  pathname: string,
): boolean {
  return shouldMountAppShell(authStatus, pathname) && isShellTreePath(pathname);
}
